(function(){
  if(window.__cherieSizeGuideV2Loaded) return;
  window.__cherieSizeGuideV2Loaded = true;

  function setUnit(modal, unit){
    modal.querySelectorAll('[data-cherie-unit]').forEach(function(button){
      var active = button.dataset.cherieUnit === unit;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    modal.querySelectorAll('[data-cherie-unit-view]').forEach(function(view){
      view.hidden = view.dataset.cherieUnitView !== unit;
    });
  }

  function setPiece(modal, index){
    modal.querySelectorAll('[data-cherie-piece-tab]').forEach(function(button){
      var active = button.dataset.cheriePieceTab === index;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    modal.querySelectorAll('[data-cherie-piece-panel]').forEach(function(panel){
      panel.hidden = panel.dataset.cheriePiecePanel !== index;
    });
  }

  function initModal(modal){
    if(!modal) return;
    setUnit(modal, modal.dataset.defaultUnit || 'in');
    setPiece(modal, '0');
  }

  document.addEventListener('click', function(event){
    var trigger = event.target.closest('[data-cherie-size-guide-open]');
    if(trigger){
      event.preventDefault();
      event.stopPropagation();
      var modal = document.getElementById(trigger.dataset.cherieSizeGuideOpen);
      if(modal && typeof modal.showModal === 'function'){
        initModal(modal);
        modal.showModal();
      }
      return;
    }

    var unitButton = event.target.closest('[data-cherie-unit]');
    if(unitButton){
      var unitModal = unitButton.closest('dialog.cherie-size-guide');
      if(unitModal) setUnit(unitModal, unitButton.dataset.cherieUnit);
      return;
    }

    var pieceButton = event.target.closest('[data-cherie-piece-tab]');
    if(pieceButton){
      var pieceModal = pieceButton.closest('dialog.cherie-size-guide');
      if(pieceModal) setPiece(pieceModal, pieceButton.dataset.cheriePieceTab);
    }
  });

  document.addEventListener('click', function(event){
    if(event.target.matches('dialog.cherie-size-guide')){
      var rect = event.target.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if(!inside) event.target.close();
    }
  });
})();
